import Loading from '@/common/atoms/Loading'
import TextError from '@/common/atoms/TextError'
import { useGovernanceFeed } from '@/log/hooks/useGovernanceFeed'
import NewsList from '@/news/components/NewsList'
import NewsLogList from '@/news/components/NewsLogList'
import NewsTabs, { NewsTab } from '@/news/components/NewsTabs'
import { useNewsFeed } from '@/news/hooks/useNewsFeed'
import { Box, Card, CardBody, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  circleId: string
}

// A circle's news, with the same two feeds as the dashboard (#109, following
// ACTU-01): the operational news, and the org chart changes of the circle and
// of everything it holds. Only the open tab subscribes.
export default function CircleNews({ circleId }: Props) {
  const { t } = useTranslation()
  const [tab, setTab] = useState<NewsTab>('news')
  const isGovernance = tab === 'governance'

  const newsFeed = useNewsFeed(circleId)
  const governanceFeed = useGovernanceFeed(circleId, !isGovernance)
  const { error, loading, bottomRef } = isGovernance ? governanceFeed : newsFeed
  const { news } = newsFeed
  const { logs } = governanceFeed

  return (
    <>
      <NewsTabs value={tab} onChange={setTab} mb={4} />

      {error && <TextError error={error} />}

      {!isGovernance && news?.length === 0 && (
        <Card boxShadow="none">
          <CardBody>
            <Text fontStyle="italic">{t('CircleNews.empty')}</Text>
          </CardBody>
        </Card>
      )}

      {!isGovernance && news && <NewsList items={news} />}

      {isGovernance && logs?.length === 0 && (
        <Card boxShadow="none">
          <CardBody>
            <Text fontStyle="italic">{t('DashboardNews.governanceEmpty')}</Text>
          </CardBody>
        </Card>
      )}

      {isGovernance && logs && <NewsLogList logs={logs} />}

      <Box ref={bottomRef} textAlign="center">
        {loading && <Loading active size="sm" mt={10} />}
      </Box>
    </>
  )
}
